var moduleName = "services.authenticate";

/**
 * Contact Server to check credentials provided
 */
class AuthenticateService {

  /**
   * Init
   * @param $http
   */
  constructor($http) {
    this.http = $http;

    this.credentials = {
      username: null,
      password: null,
      "2fa": null,
    };

    this.account = null;
    this.getAccountInfo();
  }

  /**
   * Check Variables with server
   * @param {Object} credentials
   * @param {String} username
   * @param {String} password
   * @param {Function} handleSuccess
   * @param {Function} handleError
   * @returns {*}
   */
  authenticate(credentials, username, password, handleSuccess, handleError) {
    this.credentials = credentials;
    return this.http.post("/app/authenticate", credentials).then(handleSuccess, handleError);
  }

  /**
   * Check Variables with server
   * @param {String} pin
   * @param {Function} handleSuccess
   * @param {Function} handleError
   * @returns {*}
   */
  pin(pin, handleSuccess, handleError) {
    return this.http.post("/app/pin", {
      username: this.credentials.username,
      password: this.credentials.password,
      pin: pin,
    }).then(handleSuccess, handleError);
  }

  /**
   * Return a promise with the account information
   * @returns {Promise}
   */
  getAccountInfo() {
    var self = this;
    return this.http.get("/app/get_account_info").then(function (response) {
      if (!response.data.error) {
        self.account = response.data.data.account;
      }
    });
  }

}

/**
 * Dependencies
 */
AuthenticateService.$inject = ["$http"];

/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
  .service("AuthenticateService", AuthenticateService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/authenticate.service.js
 **/